module.exports = __webpack_public_path__ + "img/Google_Analytics_Logo.cbfc056a.svg";